import { TEt3Circle } from "../../TypesNEW";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const ET3Circle = withLiteObserverAndTheme<TEt3Circle>((props) => {
  const {
    children = null,
    size,
    color,
    style,
    theme,
    withShadow,
    onClick
  } = props;
  const { unitX, shadow } = theme;

  let circleStyle = {
    display: "flex",
    height: size * unitX,
    width: size * unitX,
    backgroundColor: color,
    borderRadius: size * unitX,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    ...style
  };
  if (withShadow) {
    circleStyle = { ...circleStyle, ...shadow };
  }

  return (
    <div style={circleStyle} onClick={onClick}>
      {children}
    </div>
  );
});
export default ET3Circle;
